import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import CustomDialogWrapper from './CustomDialogWrapper/CustomDialogWrapper';

interface RefreshDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (val: string) => void;
  value: boolean;
}

const RefreshDialog: React.FC<RefreshDialogProps> = ({ open, onClose, onConfirm, value }) => {
  return (
    <CustomDialogWrapper open={open} onClose={onClose} width="552px" height="352px">
      <Grid
        style={{
          width: '552px',
          height: '352px',
        }}
      >
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '15%',
          }}
        >
          <Typography
            style={{
              fontSize: 26,
              fontWeight: 700,
              lineHeight: '29.26px',
              textAlign: 'center',
              marginTop: '15px',
            }}
          >
            Duplicate {value === true && '/ Refresh'}
          </Typography>
        </Grid>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '19.5px',
            textAlign: 'center',
            marginTop: '15px',
          }}
        >
          Do you want to {value === true && 'Refresh it or'} create a Duplicate?
        </Typography>

        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          <Button
            onClick={() => {
              onConfirm('duplicate');
              onClose();
            }}
            style={{
              color: 'white',
              width: '362px',
              height: '44px',
              marginBottom: '10px',
              fontSize: 14,
            }}
          >
            Duplicate Scenario
          </Button>
          {value === true && (
            <Button
              onClick={() => {
                onConfirm('refresh');
                onClose();
              }}
              style={{
                color: 'white',
                width: '362px',
                height: '44px',
                marginBottom: '10px',
                fontSize: 14,
              }}
            >
              Refresh Scenario
            </Button>
          )}
        </Grid>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default RefreshDialog;
